import mobileViewMap from '@/assets/img/features/mobile-view-map.png';
import moneyTree from '@/assets/img/features/money-tree.png';
import iconOne from '@/assets/img/features/icon-one.png';
import iconTwo from '@/assets/img/features/icon-two.png';
import iconThree from '@/assets/img/features/icon-three.png';
import iconFour from '@/assets/img/features/icon-four.png';
import iconEight from '@/assets/img/features/icon-eight.png';
import iconNine from '@/assets/img/features/icon-nine.png';
import iconFive from '@/assets/img/features/icon-five.png';
import iconTen from '@/assets/img/features/icon-ten.png';
import iconSeven from '@/assets/img/features/icon-seven.png';

export interface IFeature {
  title: string;
  icon: string;
  info: string;
}

export interface IFeatureListItems {
  image: string;
  features: IFeature[];
  position?: 'left' | 'right';
}

export const featureListOne: IFeature[] = [
  {
    title: 'Documenten en Rapporten',
    icon: iconOne,
    info: 'Met het beschikbaar stellen van deze module willen we de gebruiker kant-en-klare documenten bezorgen die typisch zijn voor het gebruik bij Dienstencheque bedrijven. De inhoud die normaal achteraf zou moeten worden geplaatst, gebeurt volledig automatisch na het selecteren van de betreffende persoon of personen.'
  },
  {
    title: 'SMS en Email alert',
    icon: iconEight,
    info: 'Onze SMS Gateway laat u op een eenvoudige manier toe om vanuit uw applicatie automatisch en snel SMS berichten  of e-mails te versturen en te ontvangen.'
  },
  {
    title: 'Real Time',
    icon: iconNine,
    info: 'Je kunt makkelijk met twee of meer vensters tegelijk werken. De verschillende vensters en hun aanpassingen worden continu gemonitord en worden die gegevens in real-time doorgestuurd naar de server.'
  }
];

export const featureListOneItems: IFeatureListItems = {
  position: 'left',
  image: mobileViewMap,
  features: featureListOne
};

export const featureListTwo: IFeature[] = [
  {
    title: 'Strijk Module',
    icon: iconTwo,
    info: 'De strijkmodule geeft u een duidelijke overzicht en opvolging in het strijkatelier. Het te ontvangen Dienstencheques word gelijk berekend. Ook hier kunnen de klanten via SMS of e-mail op de hoogte worden gebracht.'
  },
  {
    title: 'Inventariseren in één handomdraai',
    icon: iconThree,
    info: 'Met behulp van een gewone handscanner zijn borderellen binnen een mum van tijd gemaakt. Nadien kan je deze opslaan, afprinten of gelijk elektronisch doorsturen naar Sodexo.'
  },
  {
    title: 'Loon Administratie',
    icon: iconFour,
    info: 'Uw salarisadministratie in één keer goed. U betaalt kledijvergoeding en tijdsvergoeding alleen voor de gepresteerde prestaties. Zo betaalt u geen cent meer teveel uit.'
  }
];

export const featureListTwoItems: IFeatureListItems = {
  position: 'right',
  image: moneyTree,
  features: featureListTwo
};

export const featureListThree: IFeature[] = [
  {
    title: 'Instant Setup',
    icon: iconFive,
    info: 'Te druk, of bezig met de tijd die gemoeid is om de overstap te maken? Geen probleem ! Ons team is hier om kosteloos een account aan te maken, volledig vertrouwelijk en pijnloos.'
  },
  {
    title: 'Beheerdersconsole',
    icon: iconTen,
    info: 'Bepaal welke typen gebruikersaccounts worden toegewezen, verwijder de laatste handeling(en) of maak in één oogopslag een account aan voor een ander filiaal.'
  },
  {
    title: 'Routeplanner',
    icon: iconSeven,
    info: 'Met de losse app kan je eenvoudig de afstand tussen twee locaties berekenen en opzoeken via streetview.'
  }
];
